import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

// tenant: global — claiming an offer is what creates the company, so the route is keyed by the
// public offer slug instead of companies/:companyId.
export const useClaimSubscriptionOffer = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: claimSubscriptionOffer, isPending } = useAppMutation<
    { companyId: string },
    unknown,
    string
  >([QueryKey.CLAIM_SUBSCRIPTION_OFFER], {
    mutationFn: (slug: string) =>
      // tenant: global — offer routes are slug-keyed; the claim creates the company.
      ApiService.post<{ companyId: string }>({
        endpoint: BackendRoute.SUBSCRIPTION_OFFERS,
        routePath: [slug, 'claim'],
      }),
    onSuccess: () => {
      // The claim created (or resolved) a company — refresh the user's company lists.
      void queryClient.invalidateQueries({ queryKey: [QueryKey.GET_COMPANIES] });
    },
    // The AuthGuard owns the error UX (toast + redirect to My Companies).
    defaultErrorHandling: false,
  });

  return { claimSubscriptionOffer, isPending };
};
